import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const useDownloadDataHandler = (uid, table, startTime, endTime) => {
  const fetchDownloadData = async () => {
    const response = await axios.get(`https://windmonitoring.net/api/download/${uid}/${table}/${startTime}/${endTime}`);
    return response.data; // Return data to React Query
  };

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["DownloadData", uid, table, startTime, endTime],
    queryFn: fetchDownloadData,
    enabled: !!uid && !!table && !!startTime && !!endTime, // Only run if all parameters are set
    staleTime: Infinity, // Data doesn't go stale
    cacheTime: Infinity, // Cache indefinitely
  });

  return { data, isLoading, isError, error, refetch };
};

export default useDownloadDataHandler;

